/* ============
 * * Packaging Type Module State
 * ============
 */

export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/packagingType/state.js